import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ApiService} from "../../services/api/api.service";
import {SeriesDataService} from "../../services/series_data.service";
import {HeaderDataService} from "../../services/header_data.service";
import {SeriesConstantPermissions} from "../../_typing/series-constant-permissions";
import {EXTENDED_NOTIFICATION_DURATION_MS} from "../../shared/globals";
import {catchError, concatMap, map, take, takeUntil, tap} from "rxjs/operators";
import {from, Observable, of} from "rxjs";
import {ModelID} from "../../_typing/generic-types";
import {NotificationService} from "../../services/notification.service";
import {BaseComponent} from "../../shared/base.component";
import {HttpErrorHandler} from "../../services/http-error-handler.service";
import {DateTimeInstanceService} from "../../services/date-time-instance.service";
import {ChartDialogService} from "../../services/chart-dialog.service";

@Component({
    selector: 'series-context-menu',
    templateUrl: './series-context-menu.component.html',
    styleUrls: ['./series-context-menu.component.less']
})
export class SeriesContextMenuComponent extends BaseComponent {
    @Input() selected_series: any;
    @Input() seriesPermissionIds: ModelID[];
    @Output() emitRefreshRequest: EventEmitter<void> = new EventEmitter();
    @Output() emitClose: EventEmitter<void> = new EventEmitter();

    constructor(private api: ApiService,
                private seriesData: SeriesDataService,
                private headerData: HeaderDataService,
                private dateInst: DateTimeInstanceService,
                private notification: NotificationService,
                private chartDialogService: ChartDialogService,
                httpErrorHandler: HttpErrorHandler,) {
        super();
        this.handleError = httpErrorHandler.createHandleError('SeriesContextMenu');
    }


    openChartDialog(series_name): void {
        this.chartDialogService.openChartDialog(series_name);
        this.emitClose.next();
    }

    editSeries(series) {
        const ctrl = this;
        this.api.series.getById(series.id).toPromise().then((full_series) => {
            ctrl.seriesData.upsertSeries(null, full_series.data);
            this.emitClose.next();
        })
    }

    refreshSeries(): void {
        this.emitRefreshRequest.next();
    }

    private allowOverrideCalcs(seriesIds): Observable<boolean> {
        return this.seriesData.getSeriesPermissions(seriesIds).pipe(map(permissions => {
            if (!permissions) return false;
            return Object.keys(permissions).every(id => {
                    return permissions[id].includes(SeriesConstantPermissions.override_calculations)
                }
            );
        }));
    }

    updateCalculations(series) {
        this.seriesPermissionIds = this.seriesPermissionIds || [this.selected_series.id];
        this.allowOverrideCalcs(this.seriesPermissionIds).pipe(concatMap(allow => {
            if (!allow) {
                this.notification.openWarning("You don't have permissions to override calculations on all the selected nodes.",);
                return of(null);
            } else {
                return from(this.headerData.getCalculations(this.dateInst.dtp, [series.id], 'hour', 1))
                    .pipe(tap(() => {
                            this.emitRefreshRequest.next();
                        }),
                        catchError(this.handleError<any>('Get calculations')),
                        take(1),
                        takeUntil(this.onDestroy))
            }
        })).subscribe();
    }
}
